<script lang="ts" setup>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import Select from 'primevue/select'

const visible = defineModel<boolean>('visible', { required: true })

const emit = defineEmits<{
  confirm: [data: { reason: string, notes: string }]
}>()

const { t } = useNuxtApp().$i18n

const voidReason = ref<string>('customer_cancel')
const voidNotes = ref<string>('')

const reasonOptions = [
  { label: t('customer_cancel'), value: 'customer_cancel' },
  { label: t('kitchen_error'), value: 'kitchen_error' },
  { label: t('server_error'), value: 'server_error' },
  { label: t('allergy'), value: 'allergy' },
  { label: t('other'), value: 'other' },
]

function handleConfirm() {
  emit('confirm', {
    reason: voidReason.value,
    notes: voidNotes.value,
  })
  visible.value = false
  resetForm()
}

function handleCancel() {
  visible.value = false
  resetForm()
}

function resetForm() {
  voidReason.value = 'customer_cancel'
  voidNotes.value = ''
}
</script>

<template>
  <Dialog
    v-model:visible="visible"
    :header="t('Void Item')"
    modal
    class="w-full max-w-md"
    @hide="resetForm"
  >
    <div class="flex flex-col gap-4 py-4">
      <div class="flex flex-col gap-2">
        <label
          for="void-reason"
          class="font-semibold"
        >{{ t('Void Reason') }}</label>
        <Select
          id="void-reason"
          v-model="voidReason"
          :options="reasonOptions"
          option-label="label"
          option-value="value"
          class="w-full"
        />
      </div>

      <div class="flex flex-col gap-2">
        <label
          for="void-notes"
          class="font-semibold"
        >{{ t('Notes') }} ({{ t('Optional') }})</label>
        <Textarea
          id="void-notes"
          v-model="voidNotes"
          rows="3"
          class="w-full"
          :placeholder="t('Add any additional notes...')"
        />
      </div>
    </div>

    <template #footer>
      <div class="flex gap-2 justify-end">
        <Button
          :label="t('Cancel')"
          severity="secondary"
          outlined
          @click="handleCancel"
        />
        <Button
          :label="t('Void Item')"
          severity="danger"
          @click="handleConfirm"
        />
      </div>
    </template>
  </Dialog>
</template>
